<template>
  <router-view v-if="!$store.state.auth.isFirstLoading" />
  <ServerErrors
    v-if="$store.state.errors.isError && $route.fullPath === '/login'"
  />
  <Transition>
    <Loader v-if="$store.state.loader.isLoader" />
  </Transition>
  <ActiveEvents v-if="events.length" />
</template>

<script>
import ServerErrors from "@/components/common/ServerErrors.vue";
import Loader from "@/components/common/Loader.vue";
import ActiveEvents from "@/components/layouts/ActiveEvents.vue";
export default {
  mounted() {
    this.$store.dispatch("initTokens");
  },
  components: {
    ServerErrors,
    Loader,
    ActiveEvents,
  },
  computed: {
    events() {
      return this.$store.state.events.activeEvents;
    },
  },
};
</script>
